const PHRASES = [
  "FIERCE ATTIRE",
  "PREMIUM PRINT-ON-DEMAND",
  "STREETWEAR TEES & HOODIES",
  "WORLDWIDE SHIPPING",
  "100% HEAVYWEIGHT COTTON",
  "TIGER CLOTHING CO UK",
];

export const MarqueeStrip = () => {
  const items = [...PHRASES, ...PHRASES];
  return (
    <div
      data-testid="marquee-strip"
      className="overflow-hidden whitespace-nowrap border-y border-black bg-tiger py-3"
    >
      <div className="animate-marquee inline-flex items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {items.map((phrase, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center font-display text-lg uppercase tracking-widest text-black"
              >
                <span className="px-6">{phrase}</span>
                <span className="text-black/50">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
